import { authFetch } from '../AuthFetch';
// import { createAction } from 'redux-actions';

export const forwardToDeleteAppendDetail = (detail, card) => (
  (dispatch) => {
    let url = '/maintenance/cards/i' + card.id + '/details/i' + detail.id + '/delAppend';
    let request = {
      cardId: card.id,
      detailId: detail.id,
      refineStatus: detail.refineStatus
    };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: "FIND_FIXABLE_MAINTENANCE_DETAILS",
        payload: json
      });
    });
  }
);    

export const forwardToShowMaintenanceModifyComponentModal = (card, category) => (
  (dispatch) => {
      let payload = {
          card:card, 
          category: category
      }
    dispatch({
        type: "SHOW_MAINTENANCE_MODIFY_COMPONENT_MODAL",
        payload: payload
      });
  }
);

export const forwardToHideMaintenanceModifyComponentModal = () => (
  (dispatch) => {
    dispatch({
        type: "HIDE_MAINTENANCE_MODIFY_COMPONENT_MODAL",
        payload: null,
      });
  }
);    

export const forwardToAssignAppendCheckSet = (checkSet) => (
  (dispatch) => {
    dispatch({
        type: "ASSIGN_APPEND_CHECK_SET",
        payload: checkSet,
      });
  }
);

export const forwardToAssignAppendCheckItem = (checkItem) => (
  (dispatch) => {
    dispatch({
        type: "ASSIGN_APPEND_CHECK_ITEM",
        payload: checkItem,
      });
  }
);

export const forwardToAssignAppendCheckNote = (note) => (
  (dispatch) => {
    dispatch({
        type: "ASSIGN_APPEND_CHECK_NOTE",
        payload: note,
      });
  }
);    


export const forwardToFixDetail = (detail, card, type, fixer) => (
    (dispatch) => {
        let cardRequest = { 
            cardId : card.id,
            detailId: detail.id, 
            type: type,
            fixer: fixer
        };
        
        let url = '/maintenance/cards/i' + card.id + '/details/i' +detail.id+'/fix';
        authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
            dispatch({
                type: 'FIND_FIXABLE_MAINTENANCE_DETAILS',
                payload: json
            });
        });
    }
); 

export const forwardToFindFixableDetails = (cardPk, type) => (
    (dispatch) => {
        let cardRequest = { 
            cardId : cardPk,
            type: type 
        };
        let url = '/maintenance/cards/i' + cardPk + '/details/' + type+'/fixable';
        authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
            dispatch({
                type: 'FIND_FIXABLE_MAINTENANCE_DETAILS',
                payload: json
            });
        });
    }
);

export const forwardToAppendMissingDamageCheckDetail = (editing) => (
    (dispatch) => {
        let sts = editing.refineStatus==="ESCAPE"?"FIXED":"CREATED";
        let maintenanceDetail = {
            maintenanceCardId: editing.cardPk,
            categoryId: editing.categoryPk,
            setId: editing.setPk,
            itemId: editing.itemPk,
            note: editing.note,
            epc: editing.epc,
            refineStatus: editing.refineStatus,
            status: sts,
            creator:editing.creator
        };
        let url = '/maintenance/details/append/' + editing.refineStatus;
        authFetch('POST', url, JSON.stringify(maintenanceDetail), (json) => {
            dispatch({
                type: 'FIND_FIXABLE_MAINTENANCE_DETAILS',
                payload: json
            });
        });

        dispatch({
            type: "HIDE_APPEND_DETAIL_MODAL_AND_CLEAR",
            payload: null
        });
    }
); 



export const forwardToFindDetails = (card) => (
    (dispatch) => {
        let cardRequest = { 
            cardId : card.id,
        };
        let url = '/maintenance/cards/i' + card.id +'/details/fixable';
        authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
            dispatch({
                type: 'FIND_FIXABLE_MAINTENANCE_DETAILS',
                payload: json
            });
        });
    }
);

export const forwardToFindFixableMCards = (id) => (
    (dispatch) => {
        let cardRequest = { 
            casePk : id,
            cardStatuss: ['REFINED', 'FIXING','FIXED'] 
        };
        let url = '/maintenance/mcases/i' + id + '/cards/status';
        authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
            dispatch({
                type: 'FIND_FIXABLE_MAINTENANCE_CARDS',
                payload: json
            });
        });
    }
);

export const forwardToAssignPreprocedure = (card, type, operator) => (
    (dispatch) => {
    let url = '/maintenance/cards/i'+ card.id +"/type/" +type + "/pretreat";
    let request = {
        cardId: card.id,
        casePk:card.maintenanceCaseId,
        cardStatuss: ['REFINED', 'FIXING','FIXED'],
        type: type,
        operator: operator,
    };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: "FIND_FIXABLE_MAINTENANCE_CARDS",
        payload: json
      });
    });
  }
);

export const forwardToFindFixableMCases = (id) => (
    (dispatch) => {
    let url = '/maintenance/mcases/status';
    let request = {criteriaStatus: ['REFINED','FIXING',"FIXED"]};
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: "FIND_FIXABLE_MCASES",
        payload: json
      });
    });
  }
);

export const forwardToAssignModifyingTarget = (mcase) => (
    (dispatch) => {
        dispatch({
            type: "ASSIGN_FIXING_MCASE_TARGET",
            payload: mcase
        });
    }
);
export const forwardToAssignFixingTarget = (request) => (
    (dispatch) => {
        dispatch({
            type: "ASSIGN_FIXING_CARD_TARGET",
            payload: request
        });
    }
);

export const forwardToAssignAppendTarget = (card, appendType) => (
    (dispatch) => {
        let payload = {
            card: card,
            appendType: appendType
        }
        dispatch({
            type: "ASSIGN_APPEND_TARGET",
            payload: payload
        });
    }
);

export const forwardToSortFixableMaintenanceCards = (cards, order) => {
  let asc = order.get('asc')==undefined ? true:order.get('asc');
  let by = order.get('by');
  let clone = [];
  cards.map( (item , index) => {
    clone.push(item);
  });

  switch (by) {
    case "code":
      clone.sort((a, b) => {
        let comparison = asc ? (a.code < b.code) : (a.code > b.code);
        return comparison ? 1 : -1;
      });
      break;
    case "status":
      clone.sort((a, b) => {
        let comparison = asc ? (a.status < b.status) : (a.status > b.status);
        return comparison ? 1 : -1;
      });
      break;
    case "owner":
      clone.sort((a, b) => {
        let comparison = asc ? (a.owner < b.owner) : (a.owner > b.owner);
        return comparison ? 1 : -1;
      });
      break;
    case "unit":
      clone.sort((a, b) => {
        let comparison = asc ? (a.unit < b.unit) : (a.unit > b.unit);
        return comparison ? 1 : -1;
      });
      break;
    case "pantFixed":
      clone.sort((a, b) => {
        let aV = a.pantFixed.toString() + a.noPant.toString() + a.discardPant.toString();
        let bV = b.pantFixed.toString() + b.noPant.toString() + b.discardPant.toString();
        let comparison = asc ? (aV < bV) : (aV > bV);
        return comparison ? 1 : -1;
      });
      break;
    case "clothesFixed":
      clone.sort((a, b) => {
        let aV = a.clothesFixed.toString() + a.noClothes.toString() + a.discardClothes.toString();
        let bV = b.clothesFixed.toString() + b.noClothes.toString() + b.discardClothes.toString();
        let comparison = asc ? (aV < bV) : (aV > bV);
        return comparison ? 1 : -1;
      });
      break;
  }
   
  let ret = (dispatch) => {
    dispatch(
      {
        type: 'FIND_SORTED_FIXABLE_MAINTENANCE_CARDS',
        payload: {cards: clone, order: order},
      }
    )
  }

  return ret;
}


// WEBPACK FOOTER //
// ./src/actions/maintenanceFixAction.js